import {JSX} from 'react';
import Icon from "../Icon";
import IconAlert from "../../icons/IconAlert.tsx";
import IconCheck from "../../icons/IconCheck.tsx";
import IconExcavator from "../../icons/IconExcavator.tsx";
import IconInfo from "../../icons/IconInfo.tsx";
import IconMediaconverter from "../../icons/IconMediaconverter.tsx";
import IconReceipt from "../../icons/IconReceipt.tsx";
import IconRefresh from "../../icons/IconRefresh.tsx";
import IconReceiptCheck from "../../icons/IconReceiptCheck.tsx";
import IconRocket from "../../icons/IconRocket.tsx";
import IconRouterStroke from "../../icons/IconRouterStroke.tsx";
import IconSlashCircle from "../../icons/IconSlashCircle.tsx";
import IconTechnician from "../../icons/IconTechnician.tsx";

interface NotificationIconProps {
    icon: string;
}

export default function NotificationIcon({icon}: NotificationIconProps): JSX.Element {
    return <div className="notification-icon">{{
        'Alert':          <Icon component={IconAlert}/>,
        'Check':          <Icon component={IconCheck}/>,
        'Excavator':      <Icon component={IconExcavator}/>,
        'Info':           <Icon component={IconInfo}/>,
        'Mediaconverter': <Icon component={IconMediaconverter}/>,
        'Receipt':        <Icon component={IconReceipt}/>,
        'ReceiptCheck':   <Icon component={IconReceiptCheck}/>,
        'Refresh':        <Icon component={IconRefresh}/>,
        'Rocket':         <Icon component={IconRocket}/>,
        'Router':         <Icon component={IconRouterStroke}/>,
        'SlashCircle':    <Icon component={IconSlashCircle}/>,
        'Technician':     <Icon component={IconTechnician}/>,
    }[icon]}</div>;
}
